export default "__VITE_ASSET__D2FoR$5k__"